export * from './endpoints';
import { generatedAPI } from './endpoints';

export const notificationBannerAPI = generatedAPI.enhanceEndpoints({});
